import { Radio } from 'antd';

export const LCRadioGroup = Radio.Group;
